export const TEMPLATE_CREATION_FLOW_STEP_IDS = {
  editSections: 'edit-sections',
} as const;

export const TEMPLATE_CREATION_FLOW_SCREEN_IDS = {
  editSectionContent: 'edit-section-content',
  editSectionInstructions: 'edit-section-instructions',
} as const;
